import ReactDOMServer from "react-dom/server";
import LogoHeader from "../../../../components/common/LogoHeader";
import PayrollHeaderDisplay from "../../../../components/PayrollHeader/PayrollHeaderDisplay";
import FormFooter from "../form-payroll/form-footer/FormFooter";
import TablePayroll from "../table-payroll/TablePayroll";
import {
  waitForDocumentImages,
  preparePayrollHeaderForPrint,
} from "../../../../utils/printImageUtils";

export function PrintPayrollTable(object, headers, tfootObjects, otherData) {
  const { selectedTypes, value, signatories, otherInfo } = otherData;

  // Keep each printable row paired with its corresponding "value" row
  // so sorting/pagination won't misalign edited cell values.
  const sortedRows = object
    .map((item, originalIndex) => ({
      item: {
        ...item,
        originalIndex,
      },
      valueRow: value?.[originalIndex] ?? {},
    }))
    .sort((a, b) => {
      // 1. Compare LN
      const lnCompare = a.item.ln.localeCompare(b.item.ln, undefined, {
        sensitivity: "base",
      });
      if (lnCompare !== 0) return lnCompare;

      // 2. Compare FN if LN is same
      const fnCompare = a.item.fn.localeCompare(b.item.fn, undefined, {
        sensitivity: "base",
      });
      if (fnCompare !== 0) return fnCompare;

      // 3. Compare MN if FN is also same
      const mnCompare = a.item.mn.localeCompare(b.item.mn, undefined, {
        sensitivity: "base",
      });
      if (mnCompare !== 0) return mnCompare;

      // 4. Preserve original row order if completely same
      return a.item.originalIndex - b.item.originalIndex;
    });

  const rowsPerPage = 40;

  // Split object into pages of 10 rows each
  const paginatedData = [];
  for (let i = 0; i < sortedRows.length; i += rowsPerPage) {
    paginatedData.push(sortedRows.slice(i, i + rowsPerPage));
  }

  console.log("paginatedData", paginatedData);

  const iframe = document.createElement("iframe");
  iframe.style.position = "absolute";
  iframe.style.width = "0";
  iframe.style.height = "0";
  iframe.style.border = "none";
  document.body.appendChild(iframe);

  const iframeDoc = iframe.contentWindow.document;

  const logoStyles = {
    container: {
      display: "flex",
      flexDirection: "row",
      flexWrap: "wrap",
      justifyContent: "center",
      alignItems: "center", // this should not be "space-between"
      marginTop: "1rem",
    },
    subLabel: {
      fontFamily: "sans-serif",
      fontWeight: "bold",
      margin: 0,
    },
    centerText: {
      borderBottom: "2px solid #333",
      paddingBottom: "2px", // give a small space
      textAlign: "center",
      margin: 0,
      fontFamily: "sans-serif",
    },

    description: {
      fontSize: "13px",
      margin: 0,
    },
  };
  const defaultStyles = {
    container: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      fontFamily: "sans-serif",
    },
    inner: { width: "60%" },
    border: { backgroundColor: "#fff" },
    flex: {
      border: "1px solid #333",
      display: "flex",
      flexDirection: "row",
    },
    span: {
      display: "flex",
      alignItems: "center",
    },
    button: {
      border: "1px solid #ddd",
    },
    paragraph: {
      margin: 0,
      textAlign: "justify",
      paddingLeft: "1rem",
      flexGrow: 1,
    },
    firstContainer: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
    },
    secondContainer: {
      display: "flex",
      width: "100%",
      justifyContent: "center",
      alignItems: "flex-start",
    },
    inputContainer: {
      width: "48%",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
    },
    inputLine: {
      border: "none",
      borderBottom: "1px solid #333",
      width: "70%",
      padding: "7px 0px",
    },
    inputName: {
      width: "70%",
      border: "none",
      textAlign: "center",
      fontSize: "6px",
      margin: "0 0 3px 0",
    },
    inputPosition: {
      width: "100%",
      textAlign: "center",
      fontSize: "6px",
      border: "none",
      whiteSpace: "pre-wrap",
      wordBreak: "break-word",
      textAlign: "center",
      border: "none",
      resize: "none",
    },
    staticName: {
      fontWeight: "bold",
      margin: 0,
      textAlign: "center",
      fontSize: "6px",
    },
    positionText: {
      margin: 0,
      textAlign: "center",
    },
    dateContainer: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      width: "30%",
      padding: "0px 1.5rem",
    },
    blankDiv: {
      border: "none",
      borderBottom: "1px solid #333",
      width: "100%",
      padding: "7px 0px",
    },
    dateText: {
      margin: 0,
    },
  };
  const payrollTypeStyle = {
    fontFamily: "sans-serif",
    margin: "0",
    textAlign: "center",
    fontSize: "10px",
  };

  const mergedStyles = {
    scrollContainer: {
      width: "100%",
      display: "flex",
      // border: "1px solid red",
    },
    table: {
      // minWidth: "100%",
      // width: "100%",
      // flex: 1,

      // marginTop: "4px",
      // marginBottom: "4px",
      // textAlign: "center",
      // marginLeft: "",
      marginLeft: "20px",
      borderCollapse: "collapse",
      borderSpacing: 0,
      fontSize: "6px",
      fontFamily: "sans-serif",
    },
    td: {
      // Add horizontal padding so right-aligned values don't stick to borders
      padding: "2.5px 2px",
      fontSize: "7px",
      fontWeight: "bold",
      color: "black",
      border: "1px solid #ddd",
    },
    tr: {
      verticalAlign: "middle",
    },
    inputContainer: {
      display: "flex",
      flexDirection: "column",
      gap: "8px",
    },
    imgContainer: {
      dispay: "flex",
      alignItems: "center",
      justifyContent: "center",
      paddingTop: "8px",
    },
    img: {
      width: "120px",
    },
    noDataLbl: {
      textAlign: "center",
    },
    tfoot: {
      border: "1px solid #ddd",
    },
    tfootTabledata: {
      fontWeight: "bold",
      fontSize: "7px",
      padding: "5px 1px",
    },
    dateHdrCell: {
      border: "1px solid lightgrey",
      textAlign: "center",
      verticalAlign: "middle",
      whiteSpace: "normal",
      wordWrap: "break-word",
      width: "280px",
      minWidth: "280px",
      maxWidth: "280px",
      fontSize: "13px",
      backgroundColor: "rgb(43, 101, 156)",
      color: "white",
      WebkitPrintColorAdjust: "exact",
      printColorAdjust: "exact",
    },
    headerCell: {
      border: "1px solid lightgrey",
      textAlign: "center",
      verticalAlign: "middle",
      whiteSpace: "normal",
      wordWrap: "break-word",
      width: "20px",
      minWidth: "20px",
      maxWidth: "20px",
      fontSize: "6px",
      backgroundColor: "rgb(43, 101, 156)",
      color: "white",
      WebkitPrintColorAdjust: "exact",
      printColorAdjust: "exact",
    },
  };

  const payrollHeader = preparePayrollHeaderForPrint(
    otherInfo?.payrollHeader?.value?.header
  );

  const headerHTML = ReactDOMServer.renderToString(
    <>
      {payrollHeader ? (
        <PayrollHeaderDisplay header={payrollHeader} />
      ) : (
        <LogoHeader
          logoSrc={"/BIR.png"}
          rightLogoSrc={"/bagong_pilipinas.png"}
          altText="Print Logo"
          mainLabel="Republic Of the Philippines"
          subLabel="BUREAU OF IMMIGRATION"
          description="Patriotism * Integrity * Professionalism"
          styles={logoStyles}
        />
      )}
      <p style={payrollTypeStyle}>{selectedTypes?.payrollTypeVal ?? ""}</p>
      {/* {selectedTypes?.payrollTypes === "SP" && (
        <> */}
          <p style={payrollTypeStyle}>{otherInfo?.payrollCode ?? ""}</p>
          <p style={payrollTypeStyle}>
            {otherInfo?.periodCovered?.startDate && otherInfo?.periodCovered?.endDate
              ? `${otherInfo.periodCovered.startDate} - ${otherInfo.periodCovered.endDate}`
              : otherInfo?.selectedYear
              ? otherInfo.selectedYear
              : `${otherInfo?.monthFrom ?? ""}${
                  otherInfo?.monthTo ? ` - ${otherInfo.monthTo}` : ""
                }${otherInfo?.twentyPercentYear ? ` ${otherInfo.twentyPercentYear}` : ""}`}
          </p>
        {/* </>
      )} */}
    </>
  );

  const footerHTML = ReactDOMServer.renderToString(
    <FormFooter
      signatories={signatories}
      fontSize="4px"
      width="45%"
      styles={defaultStyles}
    />
  );

  const pageContent = paginatedData
    .map((pageData, pageIndex) => {
      const currentStartIndex = pageIndex * rowsPerPage;
      console.log(`Page ${pageIndex + 1}: startIndex = ${currentStartIndex}, rows = ${pageData.length}`);
      
      return `
      <div class="print-page">
        <div class="content">
        ${headerHTML}
        <div class="table-content">
          ${ReactDOMServer.renderToString(
            <TablePayroll
              tableHeader={headers?.tableHeader ?? []}
              primarySubHdr={headers?.primarySubHdr ?? []}
              secondarySubHdr={headers?.secondarySubHdr ?? []}
              headersKey={headers?.convertedHeaders}
              object={pageData.map((row, localIndex) => ({
                ...row.item,
                originalIndex: localIndex,
              }))}
              tfootObjects={
                pageIndex === paginatedData.length - 1 ? tfootObjects : {}
              }
              isColumShow={true}
              selectedTypes={selectedTypes}
              value={pageData.map((row) => row.valueRow)}
              styles={mergedStyles}
              isValueOnly={true}
              sortByLastname={true}
              isActive={false}
              startIndex={currentStartIndex}
            />
          )}
        </div>
        </div>
        <div class="footer-content">
          ${footerHTML}
        </div>
      
      </div>
    `;
    })
    .join("");

  const styles = Array.from(
    document.querySelectorAll("link[rel='stylesheet'], style")
  )
    .map((styleElement) => styleElement.outerHTML)
    .join("\n");

  iframeDoc.open();
  iframeDoc.write(`
    <html>
    <head>
      ${styles}
    <style>
  @page {
    size: landscape;
    margin: 0;
  }

  body {
    font-family: Arial, sans-serif;
    margin: 0;
    -webkit-print-color-adjust: exact;
    print-color-adjust: exact;
  }

  .table-content thead th {
    background-color: rgb(43, 101, 156) !important;
    color: white !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
    box-shadow: inset 0 0 0 1000px rgb(43, 101, 156);
  }

  .print-page {
    display: flex;
    flex-direction: column;
    min-height: 97vh;
    page-break-after: always;
    margin: 0;
    border: "1px solid red"
  }

  .content {
    flex: 1;
  }
    .table-content{
     margin-top: 10px;

    }

  .footer-content{
  margin-top: auto;
  }


</style>

    </head>
    <body>
      ${pageContent}
    </body>
    </html>
  `);
  iframeDoc.close();

  waitForDocumentImages(iframeDoc).then(() => {
    iframe.contentWindow.focus();
    iframe.contentWindow.print();

    setTimeout(() => {
      document.body.removeChild(iframe);
    }, 1000);
  });
}
